import React from 'react';
import { Form, Table, Divider, Input, Button, Typography, Row, Col, Space } from 'antd';

export const AccessTable = ({data, selectedRowKeys, setSelectedRowKeys}) => {

    const { Title } = Typography;
    const { Search } = Input;

    const columns = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            sorter: (a, b) => a.companyName?.length - b.companyName?.length,
        },
        {
            title: 'Username',
            dataIndex: 'username',
            sorter: (a, b) => a.username?.length - b.username?.length,
        },
    ];

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return(
        <>
        <Divider/>
        <Title level={5}>Access</Title>
        {/* <Row justify="end" style={{marginBottom: "30px"}}>
            <Col>
                <Space size="large"><p>Search:</p><Search placeholder="input search text" allowClear /></Space>
            </Col>
        </Row> */}
            <Form.Item>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    rowKey = 'username'
                    dataSource={data || []}
                    // scroll={{ x: 350 }}
                    size='small'
                    pagination={
                        {
                            total: data?.length, 
                            defaultCurrent: 1, 
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            size: 'small',
                        }
                    }
                />
            </Form.Item>
        </> 
    )
};